import React, { useState } from 'react';
import Row from 'containers/Reports/row';
import { runCertificateOnFileReport } from 'actions/reports';
import { fetchAllRequestStatus } from 'actions/utils';
import Select from 'react-select';
import { FormGroup } from '@blueprintjs/core';
import { connect } from 'react-redux';

const CertificateOnFileBase = ({
  runCertificateOnFileReport,
  fetchAllRequestStatus,
  requestStatus,
  report,
  isLoadedStatus,
  ...rest
}) => {
  const [selectedStatus, setStatus] = useState(null);

  const handleChange = (selected, setter) => {
    setter(selected);
  };
  return (
    <Row
      name="Certificate On File"
      description="Assessments with a certificate on file."
      drawer={
        <div style={{ width: '70%' }}>
          <FormGroup label="Assessment Status" labelInfo="(optional)">
            <Select
              options={requestStatus}
              getOptionLabel={option => option.statusName}
              getOptionValue={option => option.statusName}
              value={selectedStatus}
              onChange={selected => handleChange(selected, setStatus)}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runCertificateOnFileReport({
          statusName: selectedStatus && selectedStatus.statusName,
        })
      }
      data={report}
      headers={[
        { label: 'Assessment ID', key: 'vendorRequestID' },
        { label: 'Third Party Name', key: 'vendorName' },
        { label: 'Third Party Status', key: 'StatusName' },
        { label: 'Assessment Status', key: 'requestStatus' },
      ]}
      fetchReportFieldsData={() => {
        if (!isLoadedStatus) {
          fetchAllRequestStatus();
        }
      }}
      {...rest}
    />
  );
};
const mapStateToProps = state => ({
  report: state.reports.certificateOnFile,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
  requestStatus: state.utils.requestStatus,
  isLoadedStatus: state.utils.isLoadedRequestStatus,
});

const CertificateOnFile = connect(
  mapStateToProps,
  { runCertificateOnFileReport, fetchAllRequestStatus }
)(CertificateOnFileBase);

export default CertificateOnFile;
